import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppSettingsService } from './app-settings-service';
import { AuthService } from './auth-service';
import { AovCalculationService } from './aov-calculation-service';
import { UiStorage } from './ui-storage';
import { UI_STATE, UI_STATE_VALUE } from './ui-state';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
  ],
  providers: [
      AppSettingsService,
      AuthService,
      AovCalculationService,
      UiStorage,
      { provide: UI_STATE, useValue: UI_STATE_VALUE }
  ]
})
export class ServicesModule { }
